import { Text, Icon } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';

export default function OriginCell({ origin }) {
  return origin ? (
    <Text variant="body.fontSize13">{origin}</Text>
  ) : (
    <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
  );
}
